/**
 * Gets a media library asset id from a Braze CDN URL.
 * Path pattern: `/image_assets/images/{id}/original.{ext}`.
 */
export const parseMediaLibraryAssetIdFromUrl = (assetUrl: string): string | null => {
  if (!assetUrl || typeof assetUrl !== "string") {
    return null;
  }

  const urlWithoutQueryString = assetUrl.split("?")[0];
  // Braze CDN URLs end with /{24-char MongoDB ObjectId}/{filename}
  const assetIdMatch = urlWithoutQueryString.match(/\/([a-f0-9]{24})\/([^/]+)$/i);

  return assetIdMatch ? assetIdMatch[1] : null;
};
